import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callDealCategoryGetApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.dealCategory, {
    params: {
      categoryWithActiveOffer: payload?.categoryWithActiveOffer
    }
  });
  return data;
};